import type { QueryClient } from "@tanstack/react-query";

import type { Post } from "../types.ts";

export function updatePostCaches(
	queryClient: QueryClient,
	postId: string,
	update: (post: Post) => Post,
) {
	queryClient.setQueriesData<Post[]>({ queryKey: ["posts"] }, (posts) =>
		posts?.map((post) => (post.id === postId ? update(post) : post)),
	);
	queryClient.setQueriesData<Post>({ queryKey: ["post", postId] }, (post) =>
		post ? update(post) : post,
	);
}

export function removePostFromCaches(queryClient: QueryClient, postId: string) {
	queryClient.setQueriesData<Post[]>({ queryKey: ["posts"] }, (posts) =>
		posts?.filter((post) => post.id !== postId),
	);
	queryClient.removeQueries({ queryKey: ["post", postId] });
}
